import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../Redux/Hooks";
import { getWhatsAppAccounts } from "../Redux/ApiCalls/Dashboard/WhatsAppAPI";

const DEFAULT_ACCESS_ERROR =
  "Connect your WhatsApp Business account first to open messages, wallet balance, phone numbers, plan upgrades, campaigns, billing, and automation.";

export function getWhatsAppAccessMessage(accountError?: string) {
  return accountError?.trim() || DEFAULT_ACCESS_ERROR;
}

export function useWhatsAppAccess() {
  const dispatch = useAppDispatch();
  const { whatsAppAccount, accountLoading, error } = useAppSelector((state) => state.whatsapp);
  const [requested, setRequested] = useState(false);

  useEffect(() => {
    setRequested(true);
    dispatch(getWhatsAppAccounts());
  }, [dispatch]);

  const accessError = error?.account?.trim() ?? "";
  const isConnected = whatsAppAccount?.connected ?? false;

  const loading = !requested || accountLoading;
  const canAccess = useMemo(
    () => requested && !accountLoading && isConnected && !accessError,
    [requested, accountLoading, isConnected, accessError]
  );

  const refresh = useCallback(() => {
    dispatch(getWhatsAppAccounts());
  }, [dispatch]);

  return {
    loading,
    canAccess,
    accessError,
    accessMessage: getWhatsAppAccessMessage(accessError),
    refresh,
  };
}